/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { formStyles, mixins, variables } from '@blend/consumer-components';

const styles = StyleSheet.create({
  error: {
    ...mixins.paddingVertical(5),
    marginLeft: variables.globalBorderRadius,
    display: 'flex',
    lineHeight: 0,
    fontSize: 13,
    color: formStyles.errorColor,
  },
});
export namespace Wrapper {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {}
}

export const Wrapper: React.SFC<Wrapper.Props> = ({ children, ...htmlProps }) => (
  <div className={css(styles.error)} {...htmlProps}>
    {children}
  </div>
);
